import { Modal, ModalOverlay, ModalContent } from '@chakra-ui/react';
import React, { useContext } from 'react';
import {
  DialogStateContext,
  MessageKindType
} from '../context/DialogStateContextProvider';
import { TransitsContext } from '../context/TransitsContextProvider';
import { WindowSizeContext } from '../context/WindowSizeContextProvider';
import HelpDialog from '../components/organisms/dialog/help/HelpDialog';
import MessageDialog from '../components/organisms/dialog/message/MessageDialog';
import PlaceInfoDialog from '../components/organisms/dialog/place_info/PlaceInfoDialog';

// 背景色（ダイアログ内で個別に設定するとiPhoneで右端に反映されない部分があった）
const bgColors: { [keys in MessageKindType]: string | undefined } = {
  help: 'black',
  message: '#7F7F7F',
  placeInfo: 'white',
  none: undefined
};
Object.freeze(bgColors);

const DialogPlacer: React.FC = () => {
  const { dialogState, closeDialog } = useContext(DialogStateContext);
  const { transits } = useContext(TransitsContext);
  const { size } = useContext(WindowSizeContext);

  const dispDialog =
    dialogState.kind === 'help' ||
    dialogState.kind === 'message' ||
    (dialogState.kind === 'placeInfo' &&
      transits.dialog_places[dialogState.selectedPlace] &&
      dialogState.selectedTrain >= 0);

  return (
    <>
      {dispDialog && (
        <Modal isOpen={dialogState.isOpen} onClose={closeDialog}>
          <ModalOverlay>
            <ModalContent
              h='97%'
              w='90%'
              bgColor={bgColors[dialogState.kind]}
              marginTop={`${Math.floor(0.015 * size.h)}px`}
              marginBottom='0px'
              borderWidth='4px'
              borderColor={dialogState.kind === 'help' ? 'lightgrey' : 'black'}
              overflowY={'auto'}
            >
              {dialogState.kind === 'help' && <HelpDialog></HelpDialog>}
              {dialogState.kind === 'message' && (
                <MessageDialog></MessageDialog>
              )}
              {dialogState.kind === 'placeInfo' &&
                transits.dialog_places[dialogState.selectedPlace] &&
                dialogState.selectedTrain >= 0 && (
                  <PlaceInfoDialog></PlaceInfoDialog>
                )}
            </ModalContent>
          </ModalOverlay>
        </Modal>
      )}
    </>
  );
};

export default React.memo(DialogPlacer);
